import { NavLink } from 'react-router-dom';
import { useAuth } from '../lib/auth.js';
import { useWorkspace } from '../lib/workspace.js';
import { Brand } from './Brand.js';
import { WorkspaceSwitcher } from './WorkspaceSwitcher.js';

export function AppHeader() {
  const { user, signOut, platformAdmin, sessionStatus } = useAuth();
  const { can } = useWorkspace();

  return (
    <header className="app-header">
      <div className="app-header-left">
        <Brand to="/polls" />
        <WorkspaceSwitcher />
      </div>

      <nav className="app-nav">
        <NavLink to="/polls">Polls</NavLink>
        <NavLink to="/people">People</NavLink>
        {can('workspace:manage') ? <NavLink to="/settings">Settings</NavLink> : null}
        <NavLink to="/account">Account</NavLink>
        {platformAdmin ? <NavLink to="/usage">Usage</NavLink> : null}
      </nav>

      <div className="app-header-actions">
        {sessionStatus === 'reconnecting' ? (
          <span className="muted" role="status">
            Reconnecting…
          </span>
        ) : null}
        {user ? <span className="muted">{user.email}</span> : null}
        <button type="button" className="secondary" onClick={signOut}>
          Sign out
        </button>
      </div>
    </header>
  );
}
